import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { LocalStoreManager, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { take, takeUntil, timeout } from "rxjs/operators";
import { LocalSetting, LocalSettingKind } from "../local-setting-model";
import { TabletPosService } from "../../order/providers/tabletpos.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";

@Component({
  selector: "ngx-local-setting-form",
  templateUrl: "./local-setting-form.component.html",
  styleUrls: ["./local-setting-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalSettingFormComponent extends BaseFormComponent<LocalSetting> {
  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private lookupservice: LookupService,
    private storage: LocalStoreManager,
    private tabletPosService: TabletPosService,
    private splashFormService: SplashFormService
  ) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "LocalSetting";
    this.label = this.translate("ClientApp.FrontOffice.LocalSetting.LocalSettings");
    super.ngOnInit();
  }
  setdefault() {
    if (this.model.IsActive === undefined) this.model.IsActive = true;
    if (this.model.LocalSettingKindCode === LocalSettingKind.TabletPos) {
      this.orignalColumns.forEach((x) => {
        if (x.name === "TestTabletPos") x.formVisible = true;
      });
    }
    if (this.model.LocalSettingKindCode === LocalSettingKind.PosScale) {
      this.orignalColumns.forEach((x) => {
        if (x.name === "Test_btn") x.formVisible = true;
      });
    }
    if (!this.model.LocalSettingKindId) {
      this.lookupservice
        .getLookupbyCode("SALE", "LocalSettingKind", LocalSettingKind.Pos)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.LocalSettingKindId = x.Id;
          this.model.LocalSettingKindCode = x.Code;
          this.model.LocalSettingKindTitle = x.Title;
          this.setValue("LocalSettingKindId", x.Id);
          this.setValue("LocalSettingKindCode", x.Code);
          this.setValue("LocalSettingKindTitle", x.Title);
          this.setComputerName();
          this.setColumnAttribute();
        });
    }
  }
  setComputerName() {
    this.httpCommonService
      .get("LocalSetting/GetMachinName")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          this.model.ComputerName = data["ComputerName"];
          this.setValue("ComputerName", data["ComputerName"]);
          if (!this.model.Id) {
            this.setValue("Ip", data["IpAddress"]);
          }
        },
        (error) => {}
      );
  }
  async valueChange(event: any) {
    if (event.Category && event.Category === "LocalSettingKind") {
      if (event.Code === LocalSettingKind.TabletPos) {
        this.orignalColumns.forEach((x) => {
          if (x.name === "TestTabletPos") x.formVisible = true;
        });
      } else {
        this.orignalColumns.forEach((x) => {
          if (x.name === "TestTabletPos") x.formVisible = false;
        });
      }
      if (event.Code === LocalSettingKind.PosScale) {
        this.orignalColumns.forEach((x) => {
          if (x.name === "Test_btn") x.formVisible = true;
        });
      } else {
        this.orignalColumns.forEach((x) => {
          if (x.name === "Test_btn") x.formVisible = false;
        });
      }
      this.model.LocalSettingKindCode = event.Code;
      this.model.LocalSettingKindTitle = event.Title;
      this.setValue("LocalSettingKindCode", event.Code);
      this.setValue("LocalSettingKindTitle", event.Title);
      this.setColumnAttribute();
      this.cd.markForCheck();
    }
    if (event === "Test_btn") {
      this.ConnectionTest();
    }
    if (event === "TestTabletPos") {
      this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.LocalSetting.Communicating"));
      await this.tabletPosService.tabletPosTest().then(
        (resolve) => this.splashFormService.closeLoading(),
        (reject) => this.splashFormService.closeLoading()
      );
    }
    if (event === "GetPrinters") {
      this.getPrinters();
    }
  }
  ConnectionTest() {
    if (!this.formGroup.controls["Ip"].value || !this.formGroup.controls["Port"].value) {
      this.sts.showToast(
        null,
        this.translate("ClientApp.FrontOffice.LocalSetting.ProblemInCommunicationTest"),
        this.translate("ClientApp.FrontOffice.LocalSetting.NotEnoughInformationToCommunicate")
      );
      return;
    }
    const url = "http://" + this.formGroup.controls["Ip"].value + ":" + this.formGroup.controls["Port"].value + "/TestConnection";
    this.httpCommonService
      .getCustom(url)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          if (data) {
            this.sts.showDialog(
              this.translate("ClientApp.FrontOffice.LocalSetting.ConnectionSuccessful"),
              this.translate("ClientApp.FrontOffice.LocalSetting.Attention")
            );
            this.selectorService.setDataList("PrintTemplateTypeId", data);
          }
        },
        (err) => {
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.LocalSetting.ErrorsInConnectionWithService"),
            this.translate("ClientApp.FrontOffice.LocalSetting.Attention")
          );
          console.log(err);
        }
      );
  }
  tabletPosConnectionTest() {
    if (!this.formGroup.controls["Ip"].value || !this.formGroup.controls["Port"].value) {
      this.sts.showToast(
        null,
        this.translate("ClientApp.FrontOffice.LocalSetting.ProblemInCommunicationTest"),
        this.translate("ClientApp.FrontOffice.LocalSetting.NotEnoughInformationToCommunicate")
      );
      return;
    }
    const url = "http://" + this.formGroup.controls["Ip"].value + ":" + this.formGroup.controls["Port"].value + "/TestConnection";
    this.httpCommonService
      .getCustom(url)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          if (data) {
            this.sts.showDialog(
              this.translate("ClientApp.FrontOffice.LocalSetting.ConnectionSuccessful"),
              this.translate("ClientApp.FrontOffice.LocalSetting.Attention")
            );
            this.selectorService.setDataList("PrintTemplateTypeId", data);
          }
        },
        (err) => {
          this.sts.showDialog(
            this.translate("ClientApp.FrontOffice.LocalSetting.ErrorsInConnectionWithService"),
            this.translate("ClientApp.FrontOffice.LocalSetting.Attention")
          );
          console.log(err);
        }
      );
  }
  getPrinters() {
    if (!this.formGroup.controls["Ip"].value || !this.formGroup.controls["Port"].value) {
      this.sts.showToast(
        null,
        this.translate("ClientApp.FrontOffice.LocalSetting.CommunicationTrouble"),
        this.translate("ClientApp.FrontOffice.LocalSetting.NotEnoughInformationToCommunicate")
      );
      return;
    }
    const url = "http://" + this.formGroup.controls["Ip"].value + ":" + this.formGroup.controls["Port"].value + "/GetPrinters";
    this.httpCommonService
      .getCustom(url)
      .pipe(take(1),timeout(1500))
      .subscribe(
        (data: any) => {
          if (data) {
            this.selectorService.setDataList("printers", data);
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  setColumnAttribute() {
    super.setColumnAttribute();
    if (!this.orignalColumns.some((s) => s.name === "TestTabletPos")) {
      const testBtn = new form_control();
      testBtn.name = "TestTabletPos";
      testBtn.label = this.translate("ClientApp.FrontOffice.LocalSetting.TabletPosConnectionTest");
      testBtn.formVisible = true;
      testBtn.userClass = "test-tablet-btn";
      testBtn.columnNumber = 1;
      testBtn.order = 8;
      testBtn.formVisible = false;
      testBtn.controlType = FormControlTypes.Button;
      this.orignalColumns.push(testBtn);
    }
    if (!this.orignalColumns.some((s) => s.name === "Test_btn")) {
      const testBtn = new form_control();
      testBtn.name = "Test_btn";
      testBtn.label = this.translate("ClientApp.FrontOffice.LocalSetting.PosScaleConnectionTest");
      testBtn.formVisible = true;
      testBtn.userClass = "test-tablet-btn";
      testBtn.columnNumber = 1;
      testBtn.order = 8;
      testBtn.formVisible = false;
      testBtn.controlType = FormControlTypes.Button;
      this.orignalColumns.push(testBtn);
    }

    this.orignalColumns.forEach((x) => {
      if (
        x.name.includes("IsMultiMerchantPos") ||
        x.name.includes("IBANCode") ||
        x.name.includes("PosTimeOut") ||
        x.name.includes("PaymentTerminalProviderId") ||
        x.name.includes("UserName") ||
        x.name.includes("Password") ||
        x.name.includes("TerminalId") ||
        x.name.includes("IsWebService")
      )
        x.formVisible = this.model.LocalSettingKindCode === LocalSettingKind.Pos;
      // if (x.name === "IsWebService" && x.formVisible == true)
      if (x.name.includes("ReceiveOnlineInvoice") || x.name.includes("ShowOnlineInvoice"))
        x.formVisible = this.model.LocalSettingKindCode === LocalSettingKind.Delino;
      if (x.name.includes("PaymentTerminalProviderId"))
        x.formVisible = this.model.LocalSettingKindCode === LocalSettingKind.TabletPos || this.model.LocalSettingKindCode === LocalSettingKind.Pos;
      if (x.name.includes("LocalServiceIpAddress") || x.name.includes("PrintTemplateTypeId"))
        x.formVisible = this.model.LocalSettingKindCode === LocalSettingKind.Printer;
      if (x.name === "PaymentMethodId")
        x.formVisible = this.model.LocalSettingKindCode === LocalSettingKind.TabletPos || this.model.LocalSettingKindCode === LocalSettingKind.Pos;
      if (x.name.includes("Ip") || x.name.includes("Port")) x.formVisible = this.model.LocalSettingKindCode === LocalSettingKind.PosScale;
      if (x.name.includes("Password")) x.textType = "password";
    });
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
  }
  addControl() {
    this.cd.markForCheck();
  }

  public async save(): Promise<void> {
    await super.save();
    const computerName: string = this.storage.getData(ClearableCache.ComputerName);
    const data = await this.httpCommonService
      .get("LocalSetting/GetLocalSetting" + (computerName ? "?ComputerName=" + computerName : ""))
      .pipe(take(1))
      .toPromise();
    this.storage.savePermanentData(data, ClearableCache.LocalSetting);
  }
}
